import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { PDFDocument } from "./PDFDocument";

export async function downloadPDF(userName: string, tasks: any[], t: (key: string) => string) {
  const blob = await pdf(
    <PDFDocument userName={userName} tasks={tasks} t={t} />
  ).toBlob();
  saveAs(blob, "tasks.pdf");
}
